import React, { useState, useEffect } from 'react';
import { favoritesAPI, promptsAPI } from '../services/api';
import PromptCard from './PromptCard';
import './Favorites.css';

function Favorites({ currentUsername, showToast }) {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentUsername) {
      loadFavorites();
    } else {
      setLoading(false);
    }
  }, [currentUsername]);

  const loadFavorites = async () => {
    try {
      setLoading(true);
      const response = await favoritesAPI.getAll(currentUsername);
      const favorites = Array.isArray(response.data) ? response.data : [];
      
      // Fetch full prompt details
      const promptPromises = favorites.map(fav => 
        promptsAPI.getById(fav.prompt_id || fav.id).catch(() => null)
      );
      const results = await Promise.all(promptPromises);
      setPrompts(results.filter(r => r).map(r => r.data));
    } catch (err) {
      console.error('Failed to load favorites:', err);
      setPrompts([]);
    } finally {
      setLoading(false);
    }
  };

  if (!currentUsername) {
    return (
      <div className="container">
        <h1>My Favorites</h1>
        <div className="error">Please set your username to view favorites.</div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>My Favorites</h1>
      {loading ? (
        <div className="loading">Loading favorites...</div>
      ) : prompts.length === 0 ? (
        <div className="no-favorites">No favorites yet.</div>
      ) : (
        <div className="prompts-grid">
          {prompts.map(prompt => (
            <PromptCard
              key={prompt.id}
              prompt={prompt}
              currentUsername={currentUsername}
              showToast={showToast}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Favorites;
